import { metrics } from '../metrics';

export const httpClientRequestMetrics =
  () =>
  ({ requestConfig, duration, status = 0 }) => {
    const { label, method = 'GET' } = requestConfig;

    metrics.httpRequestTiming({
      method,
      status,
      duration,
      isUpstream: true,
      endpointName: label,
    });
  };

export default httpClientRequestMetrics;



// WEBPACK FOOTER //
// ./src/middleware/httpClient.js